import { takeLatest, put } from "redux-saga/effects";
import {
  IRequestObject,
  RequestType,
  reqHandler,
  RelationshipsEnums,
  withToken,
  genFetch,
  CoreJsonResponse,
} from "coral-utility";
import { carts } from "state/api/cart";
import {
  createCart,
  setCarts,
  getCartsForUser as fetchCartsForUser,
  updateCart,
} from "./actions";
import {
  AddModelToCartAction,
  ADD_MODEL_TO_CART,
  ADD_MODEL_TO_CART_FAILURE,
  Cart,
  CreateNewCartAction,
  CREATE_NEW_CART,
  CREATE_NEW_CART_FAILURE,
  DELETE_MODEL_FROM_CART,
  DELETE_MODEL_FROM_CART_FAILURE,
  GET_CARTS_FOR_USER,
  GET_CARTS_FOR_USER_FAILURE,
  RemoveModelFromCartAction,
} from "./types";

import { message } from "antd";
import "antd/lib/message/style/css";

export function* getCartsForUser() {
  try {
    const requests: IRequestObject = {
      onFetch: () =>
        genFetch(carts.getCarts())(withToken())(
        ),
      onSuccess: (coreJsonResponse: CoreJsonResponse<Cart[], any>) => {
        if (
          coreJsonResponse.data.length > 0 &&
          coreJsonResponse.data.findIndex(
            (item: any) => item.name === "Favorites"
          ) >= 0
        ) {
          return put(setCarts(coreJsonResponse.data));
        }
        return put(
          createCart({
            name: "Favorites",
            description: "Default favorites",
          })
        );
      },
      onFailure: () =>
        put({
          payload: [{ data: [], message: `Failed to get all carts for user` }],
          type: GET_CARTS_FOR_USER_FAILURE,
        }),
      onDeserialize: "json",
      type: RequestType.ONE,
    };
    yield reqHandler(requests);
  } catch (error) {
    console.log("getCartsForUser Error:", error);
  }
}

export function* createNewCart(action: CreateNewCartAction) {
  try {
    const requests: IRequestObject = {
      onFetch: () =>
        genFetch(carts.newCart(action.payload))(withToken())(
          RelationshipsEnums.INCLUDE_RELATIONS
        ),
      onSuccess: (coreJsonResponse: any) => {
        message.success("Successfully created a new cart!");
        return put(fetchCartsForUser());
      },
      onFailure: () => {
        message.success("Failed to create a new cart.");
        return put({
          payload: [{ data: [], message: `Failed to create new cart` }],
          type: CREATE_NEW_CART_FAILURE,
        });
      },
      onDeserialize: "json",
      type: RequestType.ONE,
    };
    yield reqHandler(requests);
  } catch (error) {
    console.log("createNewCart Error:", error);
  }
}

export function* addModelToCart(action: AddModelToCartAction) {
  try {
    const { cart, model } = action.payload;
    const requests: IRequestObject = {
      onFetch: () =>
        genFetch(carts.addModel(cart, model))(withToken())(
          RelationshipsEnums.INCLUDE_RELATIONS
        ),
      onSuccess: (coreJsonResponse: CoreJsonResponse<Cart, null>) => {
        message.success("Successfully added model to favorites!");
        return put(updateCart(coreJsonResponse.data));
      },
      onFailure: () => {
        message.success("Failed to add model to cart.");
        return put({
          payload: [{ data: [], message: `Failed to add model to cart` }],
          type: ADD_MODEL_TO_CART_FAILURE,
        });
      },
      onDeserialize: "json",
      type: RequestType.ONE,
    };
    yield reqHandler(requests);
  } catch (error) {
    console.log("addInstrumentsToCart Error:", error);
  }
}

// export function* deleteFavoritesList() {
//   try {
//     const requests: IRequestObject = {
//       onFetch: () =>
//         genFetch(carts.delete(action.payload))(withToken())(
//           RelationshipsEnums.NONE
//         ),
//       onSuccess: (coreJsonResponse: any) =>
//         put({
//           payload: action.payload,
//           type: DELETE_FAVORITES_LIST_SUCCESS,
//         }),
//       onFailure: () =>
//         put({
//           payload: [{ data: [], message: `Failed to delete favorites list` }],
//           type: DELETE_FAVORITES_LIST_FAILURE,
//         }),
//       onDeserialize: "json",
//       type: RequestType.ONE,
//     };
//     yield reqHandler(requests);
//   } catch (error) {
//     console.log("deleteFavoritesList Error:", error);
//   }
// }

// export function* editFavoritesList() {
//   try {
//     const requests: IRequestObject = {
//       onFetch: () =>
//         genFetch(carts.edit(action.payload))(withToken())(
//           RelationshipsEnums.NONE
//         ),
//       onSuccess: (coreJsonResponse: any) =>
//         put({
//           payload: coreJsonResponse.data,
//           type: EDIT_FAVORITES_LIST_SUCCESS,
//         }),
//       onFailure: () =>
//         put({
//           payload: [{ data: [], message: `Failed to edit favorites list` }],
//           type: EDIT_FAVORITES_LIST_FAILURE,
//         }),
//       onDeserialize: "json",
//       type: RequestType.ONE,
//     };
//     yield reqHandler(requests);
//   } catch (error) {
//     console.log("editFavoritesList Error:", error);
//   }
// }

export function* deleteInstrumentsFromCart(action: RemoveModelFromCartAction) {
  try {
    const { cart, model } = action.payload;
    const requests: IRequestObject = {
      onFetch: () =>
        genFetch(carts.removeModel(cart, model))(withToken())(
          RelationshipsEnums.INCLUDE_RELATIONS
        ),
      onSuccess: (coreJsonResponse: CoreJsonResponse<Cart, null>) => {
        message.success("Successfully removed model from favorites!");
        return put(updateCart(coreJsonResponse.data));
      },
      onFailure: () =>
        put({
          payload: [{ data: [], message: `Failed to remove model from car` }],
          type: DELETE_MODEL_FROM_CART_FAILURE,
        }),
      onDeserialize: "json",
      type: RequestType.ONE,
    };
    yield reqHandler(requests);
  } catch (error) {
    console.log("deleteInstrumentsFromCart Error:", error);
  }
}

export default function* FavoritesSagas() {
  yield takeLatest(GET_CARTS_FOR_USER, getCartsForUser);
  yield takeLatest(CREATE_NEW_CART, createNewCart);
  yield takeLatest(ADD_MODEL_TO_CART, addModelToCart);
  // yield takeLatest(DELETE_FAVORITES_LIST, deleteFavoritesList);
  // yield takeLatest(EDIT_FAVORITES_LIST, editFavoritesList);
  yield takeLatest(DELETE_MODEL_FROM_CART, deleteInstrumentsFromCart);
}
